function RankingSection() {
  const items = [
    { rank: 1, title: '暗影追踪', tag: '动作 · 悬疑', score: '9.2', hot: '本周最热' },
    { rank: 2, title: '夏日回响', tag: '剧情 · 爱情', score: '8.9', hot: '口碑佳作' },
    { rank: 3, title: '星际迷航：新纪元', tag: '科幻 · 冒险', score: '8.7', hot: '新片登榜' },
    { rank: 4, title: '迷雾剧场 S6', tag: '悬疑 · 剧集', score: '9.0', hot: '持续热播' },
    { rank: 5, title: '黄金时代经典', tag: '经典 · 修复', score: '9.5', hot: '高分推荐' },
  ];

  return (
    <section id="ranking" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          热播榜单
        </h2>
        <div className="max-w-3xl mx-auto">
          {items.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 md:gap-6 p-4 md:p-5 rounded-xl transition-colors cursor-pointer ${
                idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100'
              } hover:bg-secondary-50/60`}
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center font-heading text-xl font-bold flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-secondary-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.tag}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="text-lg font-heading text-accent-600">{item.score}</div>
                <span className="text-xs text-primary-600 bg-primary-50/80 px-2 py-0.5 rounded-md whitespace-nowrap">
                  {item.hot}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FaqSection() {
  const faqs = [
    {
      q: '草民影院的画质如何？',
      a: '草民影院全线内容支持1080P蓝光画质在线播放。依托先进的视频编码与分发技术，在保证高清画质的同时实现流畅不卡顿的观影体验，告别缓冲等待，即点即看。',
    },
    {
      q: '需要下载App才能观看吗？',
      a: '不需要。草民影院支持网页端直接观影，打开浏览器即可享受1080P蓝光画质。同时也提供Android与iOS客户端作为备选方案，按需选择即可。',
    },
    {
      q: '内容更新频率是怎样的？',
      a: '平台每日持续更新热门电影与超清电视剧，平均每日上线50+部影片。同时定期推出热门专题与经典重映计划，保持内容的新鲜与丰富。',
    },
    {
      q: '对网络速度有要求吗？',
      a: '草民影院采用智能自适应码率技术，能根据您的网络环境自动调整画质档位。在一般宽带与4G/5G移动网络下均可实现流畅不缓冲的观影体验。',
    },
    {
      q: '支持哪些设备观看？',
      a: '草民影院全面支持PC、平板、手机等主流设备。无论在电脑、iPad还是手机上，都能获得1080P蓝光画质的高清不卡顿观影体验，真正做到随时随地即点即看。',
    },
  ];

  return (
    <section id="faq" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          常见问题
        </h2>
        <div className="max-w-3xl mx-auto grid gap-4">
          {faqs.map((faq) => (
            <details
              key={faq.q}
              className="group bg-background-100 rounded-xl border border-secondary-200/50 overflow-hidden cursor-pointer"
              open
            >
              <summary className="flex items-center justify-between p-5 list-none">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <i className="ri-arrow-down-s-line text-lg text-foreground-500 group-open:rotate-180 transition-transform flex-shrink-0"></i>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

function CommentsSection() {
  const comments = [
    {
      name: '电影狂热者',
      text: '草民影院的1080P蓝光画质真的惊艳到我了，之前在其他平台总是卡顿缓冲，这边即点即看太爽了，高清不卡真的是实打实的体验。追剧观影首选！',
      date: '2026-07-29',
    },
    {
      name: '追剧小能手',
      text: '超清电视剧资源很全，画质清晰流畅不缓冲，每天晚上回家打开就能看，太方便了。强烈推荐给喜欢高清画质的影迷朋友们。',
      date: '2026-07-27',
    },
    {
      name: '画质控的日常',
      text: '作为一个对画质要求极高的人，草民影院完全满足了我的需求。1080P蓝光画质搭配流畅不卡顿的播放体验，每一帧都是享受。',
      date: '2026-07-25',
    },
  ];

  return (
    <section id="comments" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          观众点评
        </h2>
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-secondary-200/40"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="font-heading text-primary-600 text-sm">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <h3 className="font-heading text-sm text-foreground-900">{comment.name}</h3>
                  <p className="text-xs text-foreground-500">{comment.date}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function IndexSection() {
  const indices = [
    { label: '动作大片', count: '2,380部', icon: 'ri-fire-line' },
    { label: '悬疑烧脑', count: '1,560部', icon: 'ri-search-eye-line' },
    { label: '喜剧合家欢', count: '1,890部', icon: 'ri-emotion-happy-line' },
    { label: '科幻巨制', count: '980部', icon: 'ri-rocket-line' },
    { label: '剧情佳作', count: '2,150部', icon: 'ri-film-line' },
    { label: '爱情文艺', count: '1,420部', icon: 'ri-heart-line' },
    { label: '动画精选', count: '860部', icon: 'ri-paint-brush-line' },
    { label: '纪录纪实', count: '650部', icon: 'ri-camera-line' },
  ];

  return (
    <section id="index" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          分类索引
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indices.map((item) => (
            <div
              key={item.label}
              className="group bg-background-100 rounded-xl p-5 border border-secondary-200/40 hover:border-primary-200/60 hover:bg-primary-50/30 transition-all cursor-pointer text-center"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100/70 flex items-center justify-center group-hover:bg-accent-200/80 transition-colors">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-sm text-foreground-900 mb-1 whitespace-nowrap">
                {item.label}
              </h3>
              <p className="text-xs text-foreground-500">{item.count}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function SectionsB() {
  return (
    <>
      <RankingSection />
      <FaqSection />
      <CommentsSection />
      <IndexSection />
    </>
  );
}